import { Control, Controller } from "react-hook-form";
import { FormControl, InputLabel } from "@mui/material";
import React, { useState } from "react";

import { CalendarEditIcon } from "../../Icons";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { GvTextField, InputFieldError } from "../../../styles/styledComponents";

interface GvDatePickerControllerProps {
  id?: string;
  name: string;
  label: string;
  control: Control<any>;
  fullWidth?: boolean;
  disabled?: boolean;
  disableFuture?: boolean;
  minDate?: Date;
  maxDate?: Date;
  edit?: boolean;
  customIcon?: React.ComponentType;
  labelStyle?: string;
  /** Forwarded to the desktop picker's Popper (placement, popup sx, …). */
  popperProps?: object;
}

const GvDatePickerController = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  disabled = false,
  disableFuture = false,
  minDate,
  maxDate,
  edit,
  customIcon,
  labelStyle,
  popperProps,
}: GvDatePickerControllerProps) => {
  const fieldId = id || name;
  const [error, setError] = useState<string | null>();

  const getIcon = () => {
    if (customIcon) return customIcon;
    if (edit) return CalendarEditIcon;

    return undefined;
  };

  return (
    <FormControl fullWidth={fullWidth}>
      {label && (
        <InputLabel
          htmlFor={fieldId}
          className={labelStyle || ""}
        >
          {label}
        </InputLabel>
      )}
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field, fieldState }) =>
          <DesktopDatePicker
            {...field}
            inputFormat="MM/dd/yyyy"
            disableFuture={disableFuture}
            minDate={minDate}
            maxDate={maxDate}
            PopperProps={popperProps}
            components={{
              OpenPickerIcon: getIcon(),
            }}
            renderInput={(params) =>
              <GvTextField
                id={fieldId}
                disabled={disabled}
                sx={{ width: "100%" }}
                {...params}
                error={!!fieldState.error || !!error}
                helperText={fieldState.error?.message && <InputFieldError severity="error">
                  {fieldState.error?.message}</InputFieldError>}
                placeholder="MM/DD/YYYY"
              />}
            onError={setError}
          />
        }
      />
    </FormControl>
  );
};

export default GvDatePickerController;
